module.exports = __webpack_public_path__ + "static/media/home-product-4.210369f8.png";